import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, Check } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function WaitlistForm({ idPrefix, source = "landing", className = "" }) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    if (status === "loading") return;
    setStatus("loading");
    try {
      const { data } = await axios.post(`${API}/waitlist`, { email, source });
      if (data.already_registered) {
        toast("You're already on the list", { description: email });
      } else {
        toast.success("You're on the list", {
          description: `${email}. We'll be in touch before the Boston beta.`,
        });
      }
      setEmail("");
      setStatus("success");
    } catch (err) {
      const msg =
        err?.response?.data?.detail || "Something went wrong. Please try again.";
      toast.error(msg);
      setStatus("error");
    }
  };

  return (
    <form
      onSubmit={submit}
      data-testid={`${idPrefix}-form`}
      className={`flex w-full items-center gap-2 rounded-full border border-brand-purple/35 bg-black/50 p-2 pl-6 backdrop-blur-md transition-colors duration-300 focus-within:border-brand-teal/70 ${className}`}
    >
      <input
        type="email"
        required
        value={email}
        onChange={(e) => {
          setEmail(e.target.value);
          if (status === "error") setStatus("idle");
        }}
        placeholder="you@email.com"
        data-testid={`${idPrefix}-input`}
        aria-label="Email address"
        className="w-full min-w-0 flex-1 bg-transparent text-base text-brand-paper placeholder:text-brand-mist/40 focus:outline-none"
      />
      <button
        type="submit"
        data-testid={`${idPrefix}-submit`}
        disabled={status === "loading"}
        className="group flex shrink-0 items-center gap-2 rounded-full bg-brand-teal px-6 py-3.5 text-sm font-bold text-black shadow-[0_0_28px_rgba(66,246,143,0.35)] transition-all duration-300 hover:shadow-[0_0_44px_rgba(66,246,143,0.65)] hover:brightness-110 disabled:opacity-70 sm:px-7"
      >
        {status === "loading" ? (
          "Joining..."
        ) : status === "success" ? (
          <>
            <Check className="h-4 w-4" /> On the list
          </>
        ) : (
          <>
            Get early access
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </>
        )}
      </button>
    </form>
  );
}
